import { render, staticRenderFns } from "./TabScoringModelDrivers.vue?vue&type=template&id=8dcb276a&scoped=true"
import script from "./TabScoringModelDrivers.vue?vue&type=script&lang=js"
export * from "./TabScoringModelDrivers.vue?vue&type=script&lang=js"
import style0 from "./TabScoringModelDrivers.vue?vue&type=style&index=0&id=8dcb276a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcb276a",
  null
  
)

export default component.exports